export default __webpack_public_path__ + "static/media/Kitchen.90ab91e0.jpeg";